import { useTableDataFetch } from "./useTableDataFetch";
import { BASE_URL } from "../../../../constant/apiUrl";
import InvitationHistory from "./InvitationHistoryPending";
import { setDisplay } from "../../../../slices/adminPageSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getAPI } from "../../../../API/ApiService";
import { showErrorToast } from "../../../../utils/Toast/toast";

const AccessHistoryTable = () => {
  const dispatch = useDispatch();
  const hasFetched = useRef(false);
  const [user, setUser] = useState([]);

  const { rows, loading } = useTableDataFetch({
    url: `${BASE_URL}/admin/users/find-all`,
    dataTransformer: (data) =>
      data.map((item) => ({
        ...item,
        country: item?.country?.name,
        countryId: item?.country?.id,
        id: item.id,
        name:
          item.firstName && item.lastName
            ? `${item.firstName} ${item.lastName}`
            : "",
        email: item.email,
        accessType: item.roleName,
        organization: item.company,
        contactNo: item.contactNo,
        sponsorEmail: item.sponsorEmail,
        roleId: item.roleId,
        userType: item.userType,
        roleName: item.roleName,
        isGrantedAccess: item.isGrantedAccess,
        lastName: item.lastName,
        firstName: item.firstName,
        lastModifiedDate: item.lastLoginDate,
      })),
  });

  const fetchRoles = async () => {
    try {
      const response = await getAPI(`${BASE_URL}/admin/roles/find-all`);
      return response;
    } catch (error) {
      showErrorToast("Fail to load data");
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      // Fetch roles data
      fetchRoles().then((data) => {
        if (data?.status === 200) {
          setUser(data?.data?.response);
        }
      });
      dispatch(setDisplay(false));
    }
  }, [dispatch]);

  return (
    <InvitationHistory
      header={"Access history"}
      tableData={rows}
      loading={loading}
      user={user}
    />
  );
};

export default AccessHistoryTable;
